
import { FC, ReactNode } from 'react';
import { Link as RouteLink, LinkProps } from 'react-router-dom';

import Image from '../common/Image';
import { Box, BoxProps, styled } from '@mui/material';
import Center from '../common/Center';


interface IHomePageButtonProps {
    label: ReactNode;
    nav: string;
    img?: string;
    imgHover?: string;
    onClick?: () => void | Promise<void>;
}

const StyledLink = styled(Box)<BoxProps & LinkProps>(() => ({
    width: '130px',
    margin: '8px',
    textDecoration: 'none',

    "> img": {
        width: '100%'
    },

    "> img:first-of-type": {
        display: 'block'
    },

    "> img:nth-of-type(2)": {
        display: 'none'

    },

    "&:hover > img:first-of-type": {
        display: 'none'
    },

    "&:hover > img:nth-of-type(2)": {
        display: 'block'
    },

    "&:hover": {
        textDecoration: 'none'
    },

    "&:hover p, &:hover h6": {
        color: '#BAD6E1'
    },

    " p": {
        color: '#ffffff',
        textAlign: 'center',
        margin: '0',
        fontSize: '1.1rem',
        fontWeight: 'normal'
    },
    
    " p > h6": {
        color: 'white',
        fontSize: '1.1rem',
        fontWeight: '700'
    },

    "@media (min-width: 800px)": {
        padding: '0.25rem'
    },

    "@media (min-width: 992px)": {
        padding: '0.25rem'
    }
}));

const HomePageButton: FC<IHomePageButtonProps> = ({
    label,
    nav,
    img,
    imgHover
}) => {

    return (
        <StyledLink
            component={RouteLink}
            to={`/${nav}`}
        >
            <Image src={img} />
            <Image src={imgHover}/>
            <Center>
                {label}
            </Center>
        </StyledLink>
    )
}

export default HomePageButton